import React, { useState, useEffect } from 'react';
import logo from "./../../assets/logo.png";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useLocation } from "react-router-dom";
import Drawer from '@mui/material/Drawer';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import IconButton from '@mui/material/IconButton';
import SideBar from '../sidebar/SideBar';
import { TokenContext } from '../../context-helpers/TokenContext';
import { SecurityService } from '../../services/SecurityService';
import { useDispatch, useSelector } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useMsal } from "@azure/msal-react";
import MyProfileSidebar from './MyProfileSidebar';
// import SwitchPracticeModal from './SwitchPracticeModal';
import { usePrivilege } from "../../helpers";
import { FxIcon, useNavigation } from '../fx';

const Header = () => {
  const { navigate } = useNavigation();
  const privilege = usePrivilege();
  const { getToken } = React.useContext(TokenContext);
  const securityService = SecurityService({ getToken });
  const globalDispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorSettingEl, setAnchorSettingEl] = React.useState(null);
  const profileInfo = useSelector((store: any) => store.profileInfo);
  const menuOpen = Boolean(anchorEl);
  const menuSettingOpen = Boolean(anchorSettingEl);
  const { instance } = useMsal();

  const [open, setOpen] = useState(false);
  const [isProfileModalOpen, setProfileModalOpen] = useState(false);

  const actionConfig: any = {
    screen: "Headers",
    actions: {
      getMyProfile: "Get My Profile"
    }
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const toggleProfileDrawer = () => {
    setProfileModalOpen(!isProfileModalOpen);
  };

  const getMyProfile = async () => {
    try {
      let headers: any = {
        "X-Screen": actionConfig.screen,
        "X-Screen-Action": actionConfig.actions.getMyProfile
      };
      let profileData = await securityService.getMyProfile(headers);
      //reducer call to show profile details in header
      globalDispatch({ type: "update-profileinfo", payload: profileData });
    } catch (err: any) {
      console.log('getMyProfile error' + err.message);
      instance.logoutRedirect();
    }
  }

  // User icon dropdown starts
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = async () => {
    handleClose();
    handleSettingClose();
    await securityService.logout();
    instance.logoutRedirect();
  }
  // User icon dropdown end

  // Settings icon dropdown starts
  const handleSettingClick = (event: any) => {
    setAnchorSettingEl(event.currentTarget);
  };

  const handleSettingClose = () => {
    setAnchorSettingEl(null);
  };
  // Settings icon dropdown end


  const navToNotificationPreferences = () => {
    let navData = {
      targetRoute: "/notificationPreferences/"
    };
    handleSettingClose();
    navigate(navData);
  }

  useEffect(() => {
    getMyProfile();
  }, []);

  return (
    <div>
      <AppBar className="appheader">
        <Toolbar>
          <div className="header-logo">
            <img src={logo} alt="Logo" />
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}>
              <MenuRoundedIcon />
            </IconButton>
          </div>

          <div className="page-title">
            <p className="titlestyle">UnisLink Apps</p>
          </div>
          <div className="pageLogout">

            <div className="d-flex align-items-center">
              {profileInfo &&
                <div className="m-right-4 text-right">
                  {profileInfo.displayName}
                </div>
              }
              <div>
                {/* <span onClick={handleSettingClick}>
                  <FxIcon icon="fas fa-cog pointer header-icon"></FxIcon>
                </span>
                <Menu
                  id="setting-menu"
                  className="header-dropdown-menu"
                  anchorEl={anchorSettingEl}
                  open={menuSettingOpen}
                  onClose={handleSettingClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem onClick={openSignatureModal}>Signature</MenuItem> 
                </Menu>*/}
                <span onClick={toggleProfileDrawer}>
                  <FxIcon icon="far fa-id-badge pointer header-icon"></FxIcon>
                </span>

                <span onClick={handleClick}>
                  <FxIcon icon="far fa-user pointer header-icon"></FxIcon>
                </span>
              </div>
            </div>
            <Menu
              id="basic-menu"
              className="header-dropdown-menu"
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
            <Drawer variant="persistent" anchor="right" className="drawer-profile-sidebar" open={isProfileModalOpen}>
              <MyProfileSidebar />
            </Drawer >

          </div>
        </Toolbar>
        <div id="loadingbar"></div>
      </AppBar>
      <Drawer variant="persistent" anchor="left" className="drawer-sidebar" open={open}>
        {/* <span onClick={toggleDrawer}> */}
        <SideBar toggleDrawer={toggleDrawer} />
        {/* </span> */}
      </Drawer>
    </div>
  );
}
export default Header;